(function(){
  'use strict';

  var SHELL_SELECTORS = [
    '.nmps .nmps__authored-hero',
    '.nmps .nmps__quick',
    '.nmps .nmps__essential-panel',
    '.nmps .nmps__oneclick',
    '.nmps__story-content .fnx-wrap',
    '.nmps__story-content .fnx-section'
  ];

  var INNER_SELECTORS = [
    '.nmps__story-content .fnx-card',
    '.nmps__story-content .fnx-cell',
    '.nmps__story-content .fnx-s4 > div[style*="display:grid"] > div',
    '.nmps__story-content .fnx-s5 > div[style*="display:inline-grid"] > div',
    '.nmps__story-content div[style*="border-left:2px solid rgba(74,158,255,0.5)"]',
    '.nmps__story-content .fnx-wrap > div[style*="padding:14px 32px 18px"]'
  ];

  function makeBorder(){
    var border=document.createElement('span');
    border.className='nm-r187-border';
    border.setAttribute('aria-hidden','true');
    ['top','right','bottom','left'].forEach(function(side){
      var edge=document.createElement('span');
      edge.className='nm-r187-edge nm-r187-edge--'+side;
      border.appendChild(edge);
    });
    return border;
  }

  function enhance(el,kind){
    if(!el || el.nodeType!==1 || el.dataset.nmR187Live==='1') return;
    el.dataset.nmR187Live='1';
    el.classList.add('nm-r187-frame','nm-r187-frame--'+kind);
    el.insertBefore(makeBorder(),el.firstChild);
  }

  function apply(root){
    var scope=root&&root.querySelectorAll?root:document;
    SHELL_SELECTORS.forEach(function(selector){
      scope.querySelectorAll(selector).forEach(function(el){enhance(el,'shell');});
    });
    INNER_SELECTORS.forEach(function(selector){
      scope.querySelectorAll(selector).forEach(function(el){enhance(el,'inner');});
    });
    if(scope.matches){
      SHELL_SELECTORS.forEach(function(selector){if(scope.matches(selector)) enhance(scope,'shell');});
      INNER_SELECTORS.forEach(function(selector){if(scope.matches(selector)) enhance(scope,'inner');});
    }
  }

  function start(){
    apply(document);
    var observer=new MutationObserver(function(records){
      records.forEach(function(record){
        record.addedNodes.forEach(function(node){
          if(node.nodeType===1) apply(node);
        });
      });
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
